// extracted by mini-css-extract-plugin
module.exports = {"MasterData":"MasterData_MasterData__1_rDT","Button":"MasterData_Button__F_U-_"};